import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/pro-light-svg-icons";

function WatchlistTable({ title, members, onEdit, onDelete }) {

  return (
    <div className="watchlist-container">
      <h2 className="watchlist-table-title">{title}</h2>
      <div className="watchlist-heading-row watchlist-row">
        <span>NAME</span>
        <span>EMAIL</span>
        <span>NOTES</span>
      </div>
      <div>
        { members.length === 0 && (
          <p className="watchlist-empty">No members on this list.</p>
        )}

        { members.map((member) => (
          <div key={member._id} className="watchlist-row">
            <span className="cell">{member.name}</span>
            <span className="cell">{member.email}</span>
            <span className="cell">{member.notes}</span>
            <div className="member-actions">
              <button onClick={() => onEdit(member)}>
                <FontAwesomeIcon icon={faEdit} size="lg" />
              </button>
              <button onClick={() => onDelete(member)}>
                <FontAwesomeIcon icon={faTrash} size="lg" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

WatchlistTable.propTypes = {
  title: PropTypes.string,
  members: PropTypes.array,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
};

export default WatchlistTable;